import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AIService {
  constructor(private http: HttpClient) { }

  completion(type: string, id?: string) {
    return firstValueFrom(this.http.post<any>(`/api/ai/completion/${type}${id ? '/' + id : ''}`, null));
  }

  getPictureAgentSummary() {
    return firstValueFrom(this.http.get<any>('/api/ai/picture-agent/summary'));
  }

  getPictureAgentStatus() {
    return firstValueFrom(this.http.get<any>('/api/ai/picture-agent/status'));
  }

  startPictureAgent(request: { BusinessIds?: string[]; GenerateForAll?: boolean; MarkAsAiGenerated?: boolean; ReplaceExisting?: boolean }) {
    return firstValueFrom(this.http.post<any>('/api/ai/picture-agent/start', request));
  }

  stopPictureAgent() {
    return firstValueFrom(this.http.post<any>('/api/ai/picture-agent/stop', null));
  }
}